module.exports = __webpack_public_path__ + "img/zhongdu_icon.1afbaf26.gif";